import ListButton from "src/components/ListButton";
import getLullabyIcon from "src/modules/lullaby/icons/getLullabyIcon";

import LullabiesListItemContent from "./LullabiesListItemContent";
import LullabiesListItemActionIcon from "./LullabiesListItemActionIcon";

export default function LullabiesListItem({
  lullaby,
  audioController,
  onDelete,
  onEdit,
  onAdd
}) {
  let additionalIcon = (
    <LullabiesListItemActionIcon
      onDelete={onDelete}
      onEdit={onEdit}
      onAdd={onAdd}
      lullaby={lullaby}
      audioController={audioController}
    />
  );

  return (
    <ListButton
      iconFill="primary"
      content={
        <LullabiesListItemContent
          lullaby={lullaby}
          audioController={audioController}
        />
      }
      icon={getLullabyIcon(
        lullaby.identifier || lullaby.libraryIdentifier || "record"
      )}
      additionalIcon={additionalIcon}
      renderAdditionalIcon={Boolean(additionalIcon)}
      height="56px"
    />
  );
}
